import { PiCheckCircle, PiLightbulb, PiWarningCircle } from "react-icons/pi";
import { SanitizedContent } from "@/common/components-2/sanitized-content";
import { getIconClass, getSentenceClass, getSentenceTextClass } from "./sentence.styles";
import type { SentenceProps, SentenceVariant } from "./sentence.types";

const getIconComponent = (variant: SentenceVariant) => {
  // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check -- It's ok
  switch (variant) {
    case "positive": {
      return <PiCheckCircle />;
    }
    case "alert": {
      return <PiWarningCircle />;
    }
    default: {
      return <PiLightbulb />;
    }
  }
};

export function Sentence({ className, text, variant, ...props }: SentenceProps) {
  return (
    <div className={getSentenceClass({ className, variant })} {...props}>
      <div className="flex gap-2">
        <div className={getIconClass()}>{getIconComponent(variant)}</div>
        <SanitizedContent as="div" content={text} className={getSentenceTextClass()} />
      </div>
    </div>
  );
}
